"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIZES = void 0;
exports.SIZES = {
    xxs: 120,
    xs: 160,
    s: 200,
    md: 240,
    lg: 280,
};
